import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledSelect } from 'components/shared';

import { useGetDefinitionsOptions } from './hooks/useGetDefinitionsOptions';

export const ImportCronJobsContent = () => {
  const { t } = useTranslation();
  const { data: definitionsOptions } = useGetDefinitionsOptions();
  const { control } = useFormContext();

  return (
    <ControlledSelect
      label={t('cronJobs.form.importDefinition')}
      name="config.importDefinitionId"
      control={control}
      variant="outlined"
      options={definitionsOptions ?? []}
    />
  );
};
